"use client";

import { ExternalLink } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function RegulatoryHighlights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const certifications = [{
    id: 1,
    name: "FTA Approval",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/01/fta-photo-2-1.jpg",
    link: "https://tax.gov.ae/",
    description: "Federal Tax Authority"
  }, {
    id: 2,
    name: "RERA Certification",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/01/dubai-courts-photo-2.jpg",
    link: "https://www.rpdubai.ae/",
    description: "Real Estate Regulatory Agency"
  }, {
    id: 3,
    name: "ESR Compliance",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/01/ministry-of-justice.png",
    link: "https://uaeec.gov.ae/",
    description: "Economic Substance Regulations"
  }, {
    id: 4,
    name: "AML Standards",
    image: "https://rational-stag.10web.cloud/wp-content/uploads/2026/01/Central-Bank-of-the-United-Arab-Emirates.png",
    link: "https://www.centralbank.ae/",
    description: "Anti-Money Laundering"
  }];
  return <section className="py-20 !bg-[hsl(0,0%,98%)]">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`transition-all duration-[var(--duration-slow)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          {}
          <div className="mb-12 text-center">
            <h2 className="font-display text-4xl font-bold uppercase tracking-wide !text-[hsl(22,78%,26%)] lg:text-5xl">
              Our Certifications
            </h2>
            <p className="mt-4 text-lg max-w-3xl mx-auto !text-[hsl(0,0%,0%)]">
              Recognized and approved by leading regulatory authorities in the UAE
            </p>
          </div>

          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
            {}
            <div className="grid grid-cols-2 gap-6">
              {certifications.map((cert, i) => {
              if (i === 0 || i === 1) {
                return <div key={cert.id} data-index={i} className="relative flex flex-col items-center justify-center gap-4 rounded-lg p-6 shadow-soft bg-white">
                      <div className="flex min-h-[200px] md:min-h-[250px] lg:min-h-[280px] w-full items-center justify-center overflow-hidden rounded-md bg-white">
                        <img src={cert.image} alt={cert.name} className="w-full object-contain p-4 bg-white h-auto max-h-[200px] md:max-h-[250px] lg:max-h-[280px]" />
                      </div>
                    </div>;
              }
              if (i === 2) {
                return <div key={cert.id} data-index={i} className="relative flex flex-col items-center justify-center gap-4 rounded-lg p-6 shadow-soft bg-white">
                      <div className="flex min-h-[200px] md:min-h-[250px] lg:min-h-[280px] w-full items-center justify-center overflow-hidden rounded-md bg-white">
                        <img src={cert.image} alt={cert.name} className="w-full object-contain p-4 bg-white h-auto max-h-[200px] md:max-h-[250px] lg:max-h-[280px]" />
                      </div>
                      <div className="text-center">
                        {}
                      </div>
                    </div>;
              }
              return <div key={cert.id} data-index={i} className="relative flex flex-col items-center justify-center gap-4 rounded-lg p-6 shadow-soft bg-white">
                    <div className="flex min-h-[200px] md:min-h-[250px] lg:min-h-[280px] w-full items-center justify-center overflow-hidden rounded-md bg-white">
                      <img src={cert.image} alt={cert.name} className="w-full object-contain p-4 bg-white h-auto max-h-[200px] md:max-h-[250px] lg:max-h-[280px]" />
                    </div>
                    <div className="text-center">
                      {}
                    </div>
                  </div>;
            })}
            </div>

            {}
            <div className="flex flex-col justify-center gap-8">
              <div className="space-y-6">
                <div className="space-y-3">
                  <h3 className="text-2xl font-semibold !text-[hsl(22,78%,26%)]">
                    Regulatory Excellence
                  </h3>
                  <p className="leading-relaxed !text-justify !text-[hsl(0,0%,0%)]">
                    Salem Ballama Auditing maintains the highest standards of regulatory compliance and professional certification. Our approvals from UAE regulatory authorities demonstrate our commitment to excellence and adherence to local and international standards.
                  </p>
                </div>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="mt-1 h-2 w-2 rounded-full flex-shrink-0 !bg-[hsl(22,78%,26%)]" />
                    <div>
                      <h4 className="font-semibold !text-[hsl(22,78%,26%)] !font-serif">FTA Approval</h4>
                      <p className="text-sm text-muted-foreground !h-[40px]">Registered and approved by the Federal Tax Authority for VAT and Corporate Tax services</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="mt-1 h-2 w-2 rounded-full flex-shrink-0 !bg-[hsl(22,78%,26%)]" />
                    <div>
                      <h4 className="font-semibold !text-[hsl(22,78%,26%)]">Ministry Of Justice</h4>
                      <p className="text-sm text-muted-foreground !h-[50px]">A Ministry of Justice-licensed expert, formally authorized to provide expert auditing services for federal legal and banking proceedings</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="mt-1 h-2 w-2 rounded-full flex-shrink-0 !bg-[hsl(22,78%,26%)]" />
                    <div>
                      <h4 className="font-semibold !text-[hsl(22,78%,26%)]">Dubai Courts</h4>
                      <p className="text-sm text-muted-foreground !text-justify">Officially registered to provide auditing, banking and financial services under the authority of the Dubai Courts</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="mt-1 h-2 w-2 rounded-full flex-shrink-0 !bg-[hsl(22,78%,26%)]" />
                    <div>
                      <h4 className="font-semibold !text-[hsl(22,78%,26%)]">AML Standards</h4>
                      <p className="text-sm text-muted-foreground">
                        <span style={{
                        color: 'rgb(51, 51, 51)'
                      }}>
                          Full compliance with UAE Anti-Money Laundering regulations and procedures under the authority of Central Bank of UAE
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {}
            </div>
          </div>
        </div>
      </div>
    </section>;
}